import React, { RefObject } from "react";
import ChatBubble from "../ChatBubble";
import TypingIndicator from "../TypingIndicator";
import styles from "../../../css/ai-mode/chat-window/chat-window.module.css";

import { MessageUserModel } from "../../../models/platform/messageUserModel";
import { MessageAssistantModel } from "../../../models/platform/messageAssistantModel";
import { useSystemError } from "../../../components/Error/SystemErrorContext";

interface ChatWindowProps {
  messages: Array<MessageUserModel | MessageAssistantModel>;
  isBotTyping: boolean;
  activeConversationId: string | null;
  scrollRef: RefObject<HTMLDivElement>;
}

const ChatWindow: React.FC<ChatWindowProps> = ({
  messages,
  isBotTyping,
  activeConversationId,
  scrollRef,
}) => {
  const { triggerSystemError } = useSystemError();

  const handleViewLog = (assistant_message_id: string) => {
    try {
      window.open(
        `/execution-log/${assistant_message_id}`,
        "_blank",
        "width=1100,height=900,resizable=yes,scrollbars=yes"
      );
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div ref={scrollRef} className={styles.messagesScrollable}>
      <div className={styles.messagesInner}>
        {messages.length > 0 ? (
          <>
            {messages.map((msg, index) => {
              const isUser = msg.role === "user";

              const text =
                (msg as any).content ??
                (isUser
                  ? (msg as MessageUserModel).user_input
                  : (msg as MessageAssistantModel).response_text);

              const blocks = !isUser
                ? (msg as MessageAssistantModel).blocks
                : undefined;

              return (
                <ChatBubble
                  key={(msg as any)._id ?? `temp-${index}`}
                  sender={isUser ? "user" : "assistant"}
                  message={text}
                  blocks={blocks}
                  messageId={
                    !isUser
                      ? (msg as MessageAssistantModel)._id?.toString()
                      : undefined
                  }
                  onViewLog={handleViewLog}
                />
              );
            })}

            {isBotTyping && <TypingIndicator />}
          </>
        ) : activeConversationId ? (
          <div className={styles.aiWelcome}>
            <p>This conversation has no messages yet.</p>
          </div>
        ) : (
          <div className={styles.aiWelcome}>
            <h2>Welcome to Medical Device IQ</h2>
            <p>Ask me about medical device patents.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatWindow;
